import { Component, Input, OnInit } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { ListaService } from '../../../_services/lista.service';
import { forkJoin } from 'rxjs';
import {ProductosFlujoVentaPasos} from '../../../_models/productos-flujo-venta-pasos';
import {FlujoVentaPaso} from '../../../_models/flujo-venta-paso';
import {FlujoVentaPasoService} from '../../../_services/flujo-venta-paso.service';
import {ProductosFlujoVentaPasosService} from '../../../_services/productos-flujo-venta-pasos.service';
import {ProductosFlujoVentaPasosTiposPersonas} from '../../../_models/productos-flujo-venta-pasos-tipos-personas';
import {ProductosFlujoVentaPasosTiposPersonasService} from '../../../_services/productos-flujo-venta-pasos-tipos-personas.service';
import {ProductosFlujoVentaPasosTiposPreaprobados} from '../../../_models/productos-flujo-venta-pasos-tipos-preaprobados';
import {ProductosFlujoVentaPasosTiposPreaprobadosService} from '../../../_services/productos-flujo-venta-pasos-tipos-preaprobados.service';

@Component( {
  selector: 'app-producto-flujo-venta-paso',
  templateUrl: 'producto-flujo-venta-paso.component.html',
  styleUrls: ['./producto-flujo-venta-paso.component.scss']
} )

export class ProductoFlujoVentaPasoComponent implements OnInit {

  @Input() producto: Producto;
  @Input() detalle: false;
  @Input() listaTiposPersonas: SelectItem[] = [];
  lisFlujoPaso: SelectItem[] = [];
  lisFlujoPasoTodos: FlujoVentaPaso[] = [];
  carInformacionInicial = true;
  lisProductosFrecuencias: ProductosFlujoVentaPasos[] = [];
  lisProductosFrecuenciasListado: ProductosFlujoVentaPasos[] = [];
  productosFlujoVentaPasosTipoPersonas: any = null;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  lisTiposPreaprobados: SelectItem[] = [];
  mostrarFormulario = false;
  editando = false;
  nombrePasoEditando = '';

  search: string = '';

  constructor( private proFlujoVentaServicio: ProductosFlujoVentaPasosService,
               private navServicio: NavService,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private lisServicio: ListaService,
               private fluVentaPasosService: FlujoVentaPasoService,
               private productosFlujoVentaPasosTiposPersonas: ProductosFlujoVentaPasosTiposPersonasService,
               private proFlujoVentaPreaprobadoService: ProductosFlujoVentaPasosTiposPreaprobadosService) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'flujoVentaPaso', header: this.navServicio.buscarMensaje( 'PRODUCTOFLUJOVENTA.LBL_NOMBREPASO' ), sort: true },
      { field: 'tipoPersona', header: this.navServicio.buscarMensaje( 'PRODUCTOFLUJOVENTA.LBL_NATURALEZA' ), sort: true },
      { field: 'indicadorSolicitudTradicional', header: this.navServicio.buscarMensaje( 'PRODUCTOFLUJOVENTA.LBL_TRADICIONAL' ), sort: true },
      { field: 'indicadorDigital', header: this.navServicio.buscarMensaje( 'PRODUCTOFLUJOVENTA.LBL_DIGITAL' ), sort: true },
      { field: 'indicadorPreaprobado', header: this.navServicio.buscarMensaje( 'PRODUCTOFLUJOVENTA.LBL_INDICADORPREAPROBADO' ), sort: true },
      { field: 'tiposPreaprobadosLabel', header: this.navServicio.buscarMensaje( 'PRODUCTOFLUJOVENTA.LBL_TIPOPREAPROBADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    forkJoin(
      this.proFlujoVentaServicio.listadoPorIdProductoConTipoPersona( this.producto.idProducto ),
      this.fluVentaPasosService.listadoHabilitados(),
      this.lisServicio.getMasterDetails('ListasTiposPreaprobados')
    ).subscribe( ( [ lisProductosFlujo, lisFlujo, lisPre ] ) => {
      this.lisFlujoPasoTodos = lisFlujo;
      this.lisProductosFrecuencias = lisProductosFlujo;
      this.lisTiposPreaprobados = lisPre.map( ( s: any ) => {
        return { label: s.nombre, value: s.idLista };
      } );
      this.obtenerListadoProductosFlujoVenta();
      this.cargarListadoPasos();
      this.cargarFormulario();
      this.carInformacionInicial = false;
    } );
  }

  cargarListadoPasos() {
    this.lisFlujoPaso = [];
    this.lisFlujoPasoTodos.map( ( s: FlujoVentaPaso ) => {
      if ( !this.lisProductosFrecuencias.find( x => x.idFlujoVentaPaso === s.idFlujoVentaPaso && x.indicadorHabilitado ) ) {
        this.lisFlujoPaso.push( { label: s.nombre, value: s.idFlujoVentaPaso } );
      }
    } );
  }


  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProductoFlujoVentaPaso: [ null ],
      idFlujoVentaPaso: [ [], [ Validators.required ] ],
      naturaleza: [ [], [ Validators.required ] ],
      indicadorSolicitudTradicional : [false],
      indicadorPreaprobado: [false],
      indicadorDigital: [false],
      tiposPreaprobados: [ [] ]
    } );

    this.f.indicadorPreaprobado.valueChanges.subscribe( val => {
      if ( val ) {
        this.f.tiposPreaprobados.setValidators( [ Validators.required ] );
      } else {
        this.f.tiposPreaprobados.setValue( null );
        this.f.tiposPreaprobados.clearValidators();
      }
      this.f.tiposPreaprobados.updateValueAndValidity();
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  validarIndicadorObligatorio () {
    if (this.f.indicadorSolicitudTradicional.value ||
      this.f.indicadorPreaprobado.value ||
      this.f.indicadorDigital.value ) {
        return true;
    } else {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTOFLUJOVENTA.MSG_ADVERTENCIAAGREGAR' )
      } );
      return false;
    }
  }

  async onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid && this.validarIndicadorObligatorio()) {
      this.guardando = true;
      const proFrecuenciaCrear = this.formulario.value;
      const tempProductosFlujoVenta: ProductosFlujoVentaPasos[] = [];
      const temProductoTipoPersona = [];
      if ( proFrecuenciaCrear.idFlujoVentaPaso ) {
        proFrecuenciaCrear.idFlujoVentaPaso.map( s => {
          let temp  = {} as ProductosFlujoVentaPasos;
          temp.idProducto = this.producto.idProducto;
          temp.idFlujoVentaPaso = s;
          temp.indicadorHabilitado = true;
          temp.indicadorSolicitudTradicional = proFrecuenciaCrear.indicadorSolicitudTradicional;
          temp.indicadorPreaprobado = proFrecuenciaCrear.indicadorPreaprobado;
          temp.indicadorDigital = proFrecuenciaCrear.indicadorDigital;

          const a = this.lisProductosFrecuencias.find( sp => sp.idFlujoVentaPaso === s );
          if ( a ) {
            temp.idProductoFlujoVentaPaso = a.idProductoFlujoVentaPaso;
          }
          if (proFrecuenciaCrear.idProductoFlujoVentaPaso) {
             temp.idProductoFlujoVentaPaso = proFrecuenciaCrear.idProductoFlujoVentaPaso;
          }
          tempProductosFlujoVenta.push(temp);
        } );
      }

      if ( tempProductosFlujoVenta.length > 0 ) {
        this.proFlujoVentaServicio.bulk( tempProductosFlujoVenta ).subscribe( async frecuencia => {
          const listaIdsProductoFluVenta = proFrecuenciaCrear.idFlujoVentaPaso;

          listaIdsProductoFluVenta.forEach(l=> {
           if (proFrecuenciaCrear.naturaleza.length > 0) {
             proFrecuenciaCrear.naturaleza.forEach(x => {
               let obj  = {} as ProductosFlujoVentaPasosTiposPersonas;
               const _buscaReg = this.lisProductosFrecuencias.find( x => x.idFlujoVentaPaso === l && x.indicadorHabilitado );
               const auxiliar = frecuencia.find( f => f.idFlujoVentaPaso === l && f.indicadorHabilitado );

               obj.idProductoFlujoVentaPaso = _buscaReg ? _buscaReg.idProductoFlujoVentaPaso : auxiliar ? auxiliar.idProductoFlujoVentaPaso : null;
               const _buscarTipoPersona = _buscaReg && Array.isArray(_buscaReg.naturaleza) && _buscaReg.naturaleza.length > 0 ? _buscaReg.naturaleza.find(g =>g.idTipoPersona === x) : null;
               obj.idProductoFlujoVentaPasoTipoPersona = _buscarTipoPersona ? _buscarTipoPersona.idProductoFlujoVentaPasoTipoPersona : null;
               obj.indicadorHabilitado = true;
               obj.idTipoPersona = x;
               temProductoTipoPersona.push(obj);
             });
           }
          });
          if (temProductoTipoPersona.length > 0 ) {
             await this.productosFlujoVentaPasosTiposPersonas.bulk( temProductoTipoPersona).toPromise();
          }

          const temProductosPreaprobados = [];
          listaIdsProductoFluVenta.forEach(l => {
            if (proFrecuenciaCrear.tiposPreaprobados && proFrecuenciaCrear.tiposPreaprobados.length > 0) {
              proFrecuenciaCrear.tiposPreaprobados.forEach(x => {
                const obj = this.obtenerObjetoTipoPreAprobado(x, l);
                if (!obj.idProductoFlujoVentaPaso) {
                  const auxiliar = frecuencia.find( f => f.idFlujoVentaPaso === l && f.indicadorHabilitado );
                  obj.idProductoFlujoVentaPaso = auxiliar ? auxiliar.idProductoFlujoVentaPaso : null;
                }
                temProductosPreaprobados.push(obj);
              });
            }
            const reg = this.lisProductosFrecuencias.find(row => row.idFlujoVentaPaso === l && row.indicadorHabilitado);
            if (reg && reg.tiposPreaprobadosList && reg.tiposPreaprobadosList.length > 0) {
              reg.tiposPreaprobadosList.forEach(x => {
                if (!proFrecuenciaCrear.tiposPreaprobados?.find(y => y === x.idTipoPreaprobado)) {
                  const obj = this.obtenerObjetoTipoPreAprobado(x.idTipoPreaprobado, l, false);
                  if (!obj.idProductoFlujoVentaPaso) {
                    const auxiliar = frecuencia.find( f => f.idFlujoVentaPaso === l && f.indicadorHabilitado );
                    obj.idProductoFlujoVentaPaso = auxiliar ? auxiliar.idProductoFlujoVentaPaso : null;
                  }
                  temProductosPreaprobados.push(obj);
                }
              });
            }
          });

          if (temProductosPreaprobados.length > 0) {
            await this.proFlujoVentaPreaprobadoService.bulk(temProductosPreaprobados).toPromise();
          }

          await this.obtenerListadoProductosFlujoVenta(true);
          this.cargarListadoPasos();
          this.formulario.reset();
          this.setearIndicadoresFormularioReset();
          this.mostrarFormulario = false;
          this.submitted = false;
          this.guardando = false;
          this.navServicio.setMesage( 1 );
        }, error => {
          this.guardando = false;
          this.navServicio.setMesage( 3 );
        } );
      } else {
        this.navServicio.setMesage( 1 );
        this.guardando = false;
      }
    }
  }

  obtenerObjetoTipoPreAprobado(seleccionado: string, idFlujoVentaPaso: string, habilitado: boolean = true) {
    let obj = {} as ProductosFlujoVentaPasosTiposPreaprobados;
    const _buscaReg = this.lisProductosFrecuencias.find(row => row.idFlujoVentaPaso === idFlujoVentaPaso && row.indicadorHabilitado);
    obj.idProductoFlujoVentaPaso = _buscaReg ? _buscaReg.idProductoFlujoVentaPaso : null;

    // Si existe la propiedad que contiene los registros de la tabla intermedia, buscamos el ID para actualizar
    const _buscarTipoPreaprobado = _buscaReg && Array.isArray(_buscaReg.tiposPreaprobadosList) && _buscaReg.tiposPreaprobadosList.length > 0
      ? _buscaReg.tiposPreaprobadosList.find(g => g.idTipoPreaprobado === seleccionado)
      : null;

    obj.idProductoFlujoVentaPasoTipoPreaprobado = _buscarTipoPreaprobado ? _buscarTipoPreaprobado.idProductoFlujoVentaPasoTipoPreaprobado : null;
    obj.indicadorHabilitado = habilitado;
    obj.idTipoPreaprobado = seleccionado;
    return obj;
  }

  setearIndicadoresFormularioReset() {
    this.f.indicadorSolicitudTradicional.setValue(false);
    this.f.indicadorPreaprobado.setValue(false);
    this.f.indicadorDigital.setValue(false);
    this.f.tiposPreaprobados.setValue(null);
  }

  agregar() {
    this.formulario.reset();
    this.setearIndicadoresFormularioReset();
    this.editando = false;
    this.nombrePasoEditando = '';
    this.mostrarFormulario = true;
    this.submitted = false;
    this.cargarListadoPasos();
  }

  editar( row: ProductosFlujoVentaPasos ) {
    this.submitted = false;
    this.carInformacionInicial = true;
    this.cargarListadoPasos();
    const paso = this.lisFlujoPasoTodos.find( x => x.idFlujoVentaPaso === row.idFlujoVentaPaso );
    if ( paso ) {
      this.lisFlujoPaso.push( { label: paso.nombre, value: paso.idFlujoVentaPaso } );
    }

    this.editando = true;
    this.nombrePasoEditando = paso ? paso.nombre : '';

    this.formulario.patchValue( {
      idProductoFlujoVentaPaso: row.idProductoFlujoVentaPaso,
      idFlujoVentaPaso: [ row.idFlujoVentaPaso ],
      naturaleza: row.naturaleza ? row.naturaleza.filter( x => x.indicadorHabilitado ).map( x => x.idTipoPersona ) : [],
      indicadorSolicitudTradicional: row.indicadorSolicitudTradicional,
      indicadorPreaprobado: row.indicadorPreaprobado,
      indicadorDigital: row.indicadorDigital,
      tiposPreaprobados: row.tiposPreaprobadosList && row.tiposPreaprobadosList.length > 0 ? row.tiposPreaprobadosList.filter(x => x.indicadorHabilitado).map(x => x.idTipoPreaprobado) : []
    } );
    this.mostrarFormulario = true;
    this.carInformacionInicial = false;
  }

  cancelarEdit() {
    this.formulario.reset();
    this.setearIndicadoresFormularioReset();
    this.editando = false;
    this.nombrePasoEditando = '';
    this.mostrarFormulario = false;
    this.submitted = false;
    this.cargarListadoPasos();
  }

  inhabilitar( row: ProductosFlujoVentaPasos ) {
    console.log(row);
    console.log('Lo que lle')
    if ( this.producto.indicadorHabilitado && this.lisProductosFrecuenciasListado.length === 1 ) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_NOINHABILITAR' )
      } );
    } else {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'frecuencias',
        accept: () => {
          this.carInformacionInicial = true;
          row.indicadorHabilitado = false;
          this.proFlujoVentaServicio.actualizar( row ).subscribe(async regActualizado => {
            const temp: ProductosFlujoVentaPasos[] = this.lisProductosFrecuencias;
            this.lisProductosFrecuencias = [];
            temp.map( t => {
              if ( t.idProductoFlujoVentaPaso === row.idProductoFlujoVentaPaso ) {
                t.indicadorHabilitado = false;
              }
            } );
            this.lisProductosFrecuencias = temp;
            if (Array.isArray(row.naturaleza) && row.naturaleza.length > 0) {
              row.naturaleza.forEach(item => {
                item.indicadorHabilitado = false;
              })
            }
            await this.productosFlujoVentaPasosTiposPersonas.bulk(row.naturaleza).toPromise();
            await this.obtenerListadoProductosFlujoVenta(true);
            this.carInformacionInicial = false;
            this.cargarListadoPasos();
          } );
        },
        reject: () => {
        }
      } );
    }
  }

  regresar() {
    this.location.back();
  }

  async obtenerListadoProductosFlujoVenta(lanzarServicio: boolean = false) {
    if (lanzarServicio) {
      this.lisProductosFrecuencias = await this.proFlujoVentaServicio.listadoPorIdProductoConTipoPersona( this.producto.idProducto ).toPromise();
    }
    this.lisProductosFrecuenciasListado = this.lisProductosFrecuencias.filter( s => s.indicadorHabilitado );
    this.lisProductosFrecuenciasListado.forEach(x => {
      if (Array.isArray(x.naturaleza) && x.naturaleza.length > 0) {
        const lista = x.naturaleza.filter(l =>l.indicadorHabilitado ).map(l => l.tipoPersona);
        x.tipoPersona = lista.join(' - ');
      }
      if (Array.isArray(x.tiposPreaprobadosList) && x.tiposPreaprobadosList.length > 0) {
        const listado = x.tiposPreaprobadosList.filter(l => l.indicadorHabilitado ).map( l => l.tipoPreaprobado);
        x.tiposPreaprobadosLabel = listado.join( ' - ' );
      } else {
        x.tiposPreaprobadosLabel = ' -- ';
      }
    })
  }

}
